import { __extends, __rest, __assign, __makeTemplateObject } from 'tslib';
import React, { createRef, Component, forwardRef } from 'react';
import { styled } from 'styled-components';
import classnames from 'classnames';
import { SuomifiThemeConsumer } from '../../../../theme/SuomifiThemeProvider/SuomifiThemeProvider.js';
import '../../../../theme/SuomifiTheme/SuomifiTheme.js';
import '../../../../theme/SpacingProvider/SpacingProvider.js';
import '../../../../../reset/HtmlA/HtmlA.js';
import '../../../../../reset/HtmlButton/HtmlButton.js';
import '../../../../../reset/HtmlDiv/HtmlDiv.js';
import '../../../../../reset/HtmlFieldSet/HtmlFieldSet.js';
import '../../../../../reset/HtmlH/HtmlH.js';
import '../../../../../reset/HtmlInput/HtmlInput.js';
import '../../../../../reset/HtmlLabel/HtmlLabel.js';
import '../../../../../reset/HtmlLegend/HtmlLegend.js';
import '../../../../../reset/HtmlLi/HtmlLi.js';
import '../../../../../reset/HtmlNav/HtmlNav.js';
import '../../../../../reset/HtmlOl/HtmlOl.js';
import '../../../../../reset/HtmlSpan/HtmlSpan.js';
import '../../../../../reset/HtmlTextarea/HtmlTextarea.js';
import { HtmlUlWithRef } from '../../../../../reset/HtmlUl/HtmlUl.js';
import '../../../../../reset/HtmlTable/HtmlTable.js';
import '../../../../../reset/HtmlTable/HtmlTableCaption.js';
import '../../../../../reset/HtmlTable/HtmlTableHeader.js';
import '../../../../../reset/HtmlTable/HtmlTableRow.js';
import '../../../../../reset/HtmlTable/HtmlTableBody.js';
import '../../../../../reset/HtmlTable/HtmlTableHeaderCell.js';
import '../../../../../reset/HtmlTable/HtmlTableCell.js';
import { forkRefs } from '../../../../../utils/common/common.js';
import { baseStyles } from './SelectItemList.baseStyles.js';

var baseClassName = 'fi-select-item-list';
var BaseSelectItemList = function (_super) {
  __extends(BaseSelectItemList, _super);
  function BaseSelectItemList(props) {
    var _this = _super.call(this, props) || this;
    _this.scrollItemList = function (elementId) {
      var _a, _b;
      var wrapperOffsetPx = 4;
      if (_this.wrapperRef !== null && _this.wrapperRef.current !== null) {
        var elementOffsetTop = ((_a = document.getElementById(elementId)) === null || _a === void 0 ? void 0 : _a.offsetTop) || 0;
        var elementOffsetHeight = ((_b = document.getElementById(elementId)) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0;
        if (elementOffsetTop < _this.wrapperRef.current.scrollTop) {
          _this.wrapperRef.current.scrollTop = elementOffsetTop - wrapperOffsetPx;
        } else {
          var offsetBottom = elementOffsetTop + elementOffsetHeight;
          var scrollBottom = _this.wrapperRef.current.scrollTop + _this.wrapperRef.current.offsetHeight;
          if (offsetBottom > scrollBottom) {
            _this.wrapperRef.current.scrollTop = offsetBottom - _this.wrapperRef.current.offsetHeight - wrapperOffsetPx;
          }
        }
      }
    };
    _this.wrapperRef = /*#__PURE__*/createRef();
    return _this;
  }
  BaseSelectItemList.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.focusedDescendantId !== prevProps.focusedDescendantId && !!this.props.focusedDescendantId && !this.props.preventScrolling) {
      this.scrollItemList(this.props.focusedDescendantId);
    }
  };
  BaseSelectItemList.prototype.componentDidMount = function () {
    if (!!this.props.focusedDescendantId && !this.props.preventScrolling) {
      this.scrollItemList(this.props.focusedDescendantId);
    }
  };
  BaseSelectItemList.prototype.render = function () {
    var _a = this.props,
      className = _a.className;
      _a.theme;
      var forwardedRef = _a.forwardedRef,
      children = _a.children,
      onBlur = _a.onBlur,
      onKeyDown = _a.onKeyDown,
      id = _a.id,
      focusedDescendantId = _a.focusedDescendantId;
      _a.preventScrolling;
      var passProps = __rest(_a, ["className", "theme", "forwardedRef", "children", "onBlur", "onKeyDown", "id", "focusedDescendantId", "preventScrolling"]);
    return /*#__PURE__*/React.createElement(HtmlUlWithRef, __assign({
      id: id,
      tabIndex: 0,
      forwardRef: forkRefs(this.wrapperRef, forwardedRef),
      className: classnames(baseClassName, className, {})
    }, passProps, {
      role: "listbox",
      onBlur: onBlur,
      onKeyDown: onKeyDown,
      "aria-activedescendant": focusedDescendantId
    }), children);
  };
  return BaseSelectItemList;
}(Component);
var StyledSelectItemList = styled(BaseSelectItemList).withConfig({
  componentId: "sc-1x4qiwd-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return baseStyles(theme);
});
var SelectItemList = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SuomifiThemeConsumer, null, function (_a) {
    var suomifiTheme = _a.suomifiTheme;
    return /*#__PURE__*/React.createElement(StyledSelectItemList, __assign({
      theme: suomifiTheme,
      forwardedRef: ref
    }, props));
  });
});
var templateObject_1;

export { SelectItemList };
//# sourceMappingURL=SelectItemList.js.map
